import React, {useMemo} from 'react';
import Modal from '../../../../../../../../../components-new/ui/Modal';
import PropTypes from 'prop-types';
import Translate from "../../../../../../../../../components/Translate";
import config from "../../../../../../../../../config";
import SearchInput from "../../../../../../../../../components-new/form/SearchInput";
import SilverButton from "../../../../../../../../../components-new/buttons/SilverButton";
import PlusIcon from "../../../../../../../../../assets/icons/PlusIcon";
import Template from "../../../../../../../../../components-new/general/Template";
import {generalModalStyles} from "../../../../../../../../../utils/General";
import colors from "../../../../../../../../../utils/Colors";

Modal.setAppElement('#root');

const TemplatesViewModal = ({
                                templates,
                                isOpen,
                                handleSaveTemplate,
                                handleDeleteTemplate,
                                removeNewTemplate,
                                folderName,
                                addTemplate,
                                search,
                                setSearch,
                                onClose
                            }) => {


    const filteredTemplates = useMemo(
        () => {
            return templates.filter(t => t.folderName === folderName && t.text.toLowerCase().includes(search.toLowerCase()))
                .sort((a, b) => (b.id === null) - (a.id === null) || b.id - a.id)
        }
        ,
        [templates, folderName, search]);

    return (
        <Modal
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen={isOpen}
            onRequestClose={onClose}
            title={<React.Fragment><Translate text="templates"/> ({folderName}) ({filteredTemplates.length})</React.Fragment>}
            style={generalModalStyles.standardModalStyles}
            footer={<SilverButton type="button" width="auto" height="40px" onClick={onClose}>
                <Translate text="close"/>
            </SilverButton>}
        >
            <div
                style={{
                    maxWidth: '100%',
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '100%',
                    minHeight: '700px',
                }}>
                <div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 10px'
                    }}>
                        <SearchInput
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            style={{width: '350px'}}
                        />

                        <SilverButton
                            width={'200px'}
                            height={'48px'}
                            styles={{
                                padding: '8px',
                            }}
                            onClick={() => addTemplate(folderName)}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}>
                                <PlusIcon
                                    width={18}
                                    height={18}
                                    style={{color: colors.silverDark}} stroke="currentColor"
                                />
                                <span style={{
                                    fontSize: '13px',
                                    color: colors.silverDark,
                                    fontWeight: 'bold'
                                }}>
                                   <Translate text={'addTemplate'}/>
                            </span>
                            </div>
                        </SilverButton>
                    </div>

                    <ul style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        padding: '10px',
                        marginTop: '16px',
                        marginBottom: '16px',
                        overflowY: 'auto',
                        maxHeight: '500px'
                    }}>
                        {filteredTemplates.map((template) => (
                            <Template
                                key={template.id}
                                text={template.text}
                                onDelete={() => handleDeleteTemplate(template.id)}
                                onSave={(val) => handleSaveTemplate(template.id, val, folderName)}
                                defaultEditable={template.isNew}
                                onCancelEdit={() => template.id === null ? removeNewTemplate(folderName) : ''}
                                variant="management"
                            />
                        ))
                        }
                        {
                            filteredTemplates.length === 0 &&
                            <span className="templates-no-result" style={{marginTop: '150px'}}>
                                <Translate text="noTemplates"/>
                            </span>
                        }
                    </ul>
                </div>

            </div>
        </Modal>
    );
};

TemplatesViewModal.propTypes = {
    templates: PropTypes.array.isRequired
};

export default TemplatesViewModal;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/templates/partials/TemplatesViewModal.jsx